// Single entry point for Wasapi pt_BR strings (imported once from i18n/locale/pt_BR/index.js).
import common from '../common/i18n/pt_BR.json';
import crm from '../crm/i18n/pt_BR.json';
import dashboardApps from '../dashboard-apps/i18n/pt_BR.json';
import reactions from '../reactions/i18n/pt_BR.json';
import capi from '../capi/i18n/pt_BR.json';
import forward from '../forward/i18n/pt_BR.json';
import scheduled from '../scheduled-messages/i18n/pt_BR.json';
import campaigns from '../campaigns/i18n/pt_BR.json';
import windowTimers from '../window-timers/i18n/pt_BR.json';
import flows from '../flows/i18n/pt_BR.json';
import appointments from '../appointments/i18n/pt_BR.json';
import internalChats from '../internal-chats/i18n/pt_BR.json';
import projects from '../projects/i18n/pt_BR.json';
import templates from '../templates/i18n/pt_BR.json';

export default {
  ...common,
  ...crm,
  ...dashboardApps,
  ...reactions,
  ...capi,
  ...forward,
  ...scheduled,
  ...campaigns,
  ...windowTimers,
  ...flows,
  ...appointments,
  ...internalChats,
  ...projects,
  ...templates,
};
